import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Avatar from './Avatar';

const Layout = () => {
  const { user, logout, myPhoto } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="app-shell">
      <div className="topbar">
        <div className="brand">
          {/* The club's white roundel, supplied by the club on 02/11/2026. The
              white version because this bar is navy. Served from public/ as a
              plain file rather than imported, so swapping the badge is dropping
              a new file in rather than a rebuild of the bundle.

              alt is empty on purpose: the club's name is already written out
              immediately to the right of it, so a screen reader announcing the
              logo as well would just say it twice. */}
          <img src="/cop-roundel-white.png" alt="" />
          <div>
            City of Preston Basketball
            <small>Preston Basketball CIC — Coach Portal</small>
          </div>
        </div>
        <nav>
          {/* Somebody still on a password an admin chose for them gets one link
              and one job. The routes already redirect them (see App.js), so
              leaving the full menu drawn would only give them six tabs that all
              bounce back to the same form. */}
          {user.must_change_password ? (
            <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>
              {user.role === 'admin' ? 'My account' : 'My profile'}
            </NavLink>
          ) : user.outstanding_agreements > 0 ? (
            /* Same again for a coach who has not signed the club's documents.
               Every other route bounces them straight back here, so drawing
               the full menu would only hand them tabs that go nowhere. */
            <NavLink to="/agreements" className={({ isActive }) => isActive ? 'active' : ''}>
              Before you start
            </NavLink>
          ) : user.role === 'admin' ? (
            <>
              <NavLink to="/submissions" className={({ isActive }) => isActive ? 'active' : ''}>Submissions</NavLink>
              <NavLink to="/bills" className={({ isActive }) => isActive ? 'active' : ''}>Bills</NavLink>
              <NavLink to="/coaches" className={({ isActive }) => isActive ? 'active' : ''}>Coaches</NavLink>
              <NavLink to="/venues" className={({ isActive }) => isActive ? 'active' : ''}>Venues</NavLink>
              <NavLink to="/teams" className={({ isActive }) => isActive ? 'active' : ''}>Sessions</NavLink>
              <NavLink to="/fixtures" className={({ isActive }) => isActive ? 'active' : ''}>Fixtures</NavLink>
              {/* Same page as a coach's "My profile", same route. An admin has
                  no photo on it, so it is only their details and the
                  change-password form, and "My account" is the honest name
                  for that. */}
              <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>My account</NavLink>
            </>
          ) : (
            <>
              <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>My hours</NavLink>
              <NavLink to="/profile" className={({ isActive }) => isActive ? 'active' : ''}>My profile</NavLink>
            </>
          )}
          {/* A coach sees their own face here. An admin has no photo, so
              their initials. Either way something is always drawn, so the bar
              never changes height. */}
          <span className="topbar-user">
            <Avatar name={user.name} src={user.role === 'coach' ? myPhoto.small : null} size="md" />
            {user.name}
          </span>
          <button onClick={doLogout}>Log out</button>
        </nav>
      </div>
      <div className="container">
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
